import React from 'react';
import {
  Container,
  Header,
  Segment,
  Dimmer,
  Loader,
  Card,
  Item,
  Icon,
  Button,
  Image,
  Divider,
  Grid
} from 'semantic-ui-react';
import Api from '../api';

import audoryIcon from '../img/audory-icon-button.png';

import DivWrapper from './DivWrapper';
import moment from 'moment';
import 'moment/locale/de';
import AgeRestriction from './AgeRestriction';
import { FormattedMessage } from 'react-intl';

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import applePic from '../img/apple-badge.png';
import googlePlayPic from '../img/google-play-badge.png';

var lang = navigator.language || navigator.userLanguage;

if(lang === "de-DE") moment.locale('de');

const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };


const PageHeader = ({mobile}) => (
    <Segment 
        inverted
        textAlign='center'
        style={{ padding: '0em 0em' }}
        vertical
      >
      <Container text style={{padding: '5em 0em'}}>
        <Header
            as='h1'
            inverted
            style={{
            fontSize: mobile ? '2em' : '4em',
            fontWeight: 'normal',
            marginBottom: 0,
            }}
            >
            <FormattedMessage id="audory.responsiveContainer.body.audiobooks"/>
        </Header>
        <Header
            as='h2'
            inverted
            style={{
            fontSize: mobile ? '1.5em' : '1.7em',
            fontWeight: 'normal',
            }}
        >
            <FormattedMessage id="audory.homepage.decide.userText"/>
        </Header>
        
        </Container>
    </Segment>
)


class AudiobooksPage extends React.Component {

    state = {
        storys: null,
        storyOriginals: null,
        storyExclusive: null,
        isLoading: false,
        structure: null,
        covers: {}
    };

    async fetchCategories() {
        return await Api.Categories.getAll().then((data) => data.data);
    };

    async componentWillMount() {
        this.setState({isLoading: true});
        let structure = await Api.Story.getPersonalStructure().then(data => data.data.structure).catch(err => []);
        this.setState({structure: structure});
        let covers = {};
        for(let i=0; i<structure.length; i++){
            if(structure[i].type === "single"){
                if(!(structure[i].payload.id in covers)){
                    covers[structure[i].payload.id] = await Api.Cover.getCoverFile(structure[i].payload.cover).then(data => data.data.signed).catch(err => null);
                }
            } else if(structure[i].type === "list"){
                let stories = structure[i].payload;
                for(let j=0; j< stories.length; j++){
                    if(!(stories[j].id in covers)){
                        covers[stories[j].id] = await Api.Cover.getCoverFile(stories[j].cover).then(data => data.data.signed).catch(err => null);
                    }
                }
            }
        }
        this.setState({covers: covers, isLoading: false});
        //console.log(structure, covers);
        return ;
        let storys = await Api.Story.getAll().then(data => data.data.stories).catch(err => []);
        //storys = storys.filter(s => !s.isOriginal);

        //const categories = await this.fetchCategories();

        let renderStorys = [];
        let renderOriginalStorys = [];
        let renderExclusiveStorys = [];

        for(let i=0; i < storys.length; i++){
            /*
            if(typeof(storys[i].authorId) !== 'string'){
                storys[i].authorName = [];
                for(let k = 0; k < storys[i].authorId.length; k++) storys[i].authorName.push(
                    await Api.User.getName(storys[i].authorId[k]).then(data => data.data).catch(err => null)
                );
            } else {
                storys[i].authorName = await Api.User.getName(storys[i].authorId).then(data => data.data).catch(err => null);
            }

            if(typeof(storys[i].speakerId) !== 'string'){
                storys[i].speakerName = [];
                for(let k = 0; k < storys[i].speakerId.length; k++) storys[i].speakerName.push(
                    await Api.User.getName(storys[i].speakerId[k]).then(data => data.data).catch(err => null)
                );
            } else {
                storys[i].speakerName = await Api.User.getName(storys[i].speakerId).then(data => data.data).catch(err => null);
            }
            
            storys[i].category = categories.find(cat => cat.id === storys[i].category);
            */
            storys[i].cover = await Api.Cover.getCoverFile(storys[i].cover).then(data => data.data.signed).catch(err => null);
            /*
            storys[i].ownerName = await Api.User.getName(storys[i].ownerId).then(data => data.data).catch(err => null);
            */
            if(storys[i].isOriginal){
                renderOriginalStorys.push(storys[i]);
            } else if(storys[i].isExclusive){
                renderExclusiveStorys.push(storys[i]);
            } else {
                renderStorys.push(storys[i]);
            }
            
            if(false && !this._isUnmounted){
                this.setState({
                    storys: renderStorys,
                    storyOriginals: renderOriginalStorys,
                    storyExclusive: renderExclusiveStorys
                });
            }
        }
        if(!this._isUnmounted){
            this.setState({
                isLoading: false,
                storys: renderStorys,
                storyOriginals: renderOriginalStorys,
                storyExclusive: renderExclusiveStorys
            });
        }
    };

    componentWillUnmount(){
        this._isUnmounted=true;
    }

    renderStorys(storys){
        let ary = [];
        for(let i=0; i < storys.length; i++){
            const s = storys[i];
            /*
            let authorRender = null;
            if(typeof(s.authorId) !== 'string'){
                let authors = [];
                for(let k=0; k < s.authorName.length; k++){
                    authors.push(
                        <b key={k} style={{cursor: "pointer"}} onClick={this.handleGoToUser.bind(this, s.authorId[k])}>{`${s.authorName[k].firstName} ${s.authorName[k].lastName}`}</b>
                    );
                    if(k + 1 < s.authorName.length) authors.push(
                       <span key={k.toString() + "-&"}>&</span>
                    );
                }
                authorRender = (
                    <p>
                        <span>von {authors}</span><br/>
                    </p>
                );
            } else {
                authorRender = (
                    <p>
                        <span>von <b style={{cursor: "pointer"}} onClick={this.handleGoToUser.bind(this, s.authorId)}>{`${s.authorName.firstName} ${s.authorName.lastName}`}</b></span><br/>
                    </p>
                );
            }

            let speakerRender = null;
            if(typeof(s.speakerId) !== 'string'){
                let speakers = [];
                for(let k=0; k < s.speakerName.length; k++){
                    speakers.push(
                        <b key={k} style={{cursor: "pointer"}} onClick={this.handleGoToUser.bind(this, s.speakerId[k])}>{`${s.speakerName[k].firstName} ${s.speakerName[k].lastName}`}</b>
                    );
                    if(k + 1 < s.speakerName.length) speakers.push(
                       <span key={k.toString() + "-&"}>&</span>
                    );
                }
                speakerRender = (
                    <p>
                        gesprochen von {speakers}
                    </p>
                );
            } else {
                speakerRender = (
                    <p>
                        <span>gesprochen von <b style={{cursor: "pointer"}} onClick={this.handleGoToUser.bind(this, s.speakerId)}>{`${s.speakerName.firstName} ${s.speakerName.lastName}`}</b></span>
                    </p>
                );
            }
            */
            ary.push(
            <Card key={i}>
                {this.state.isLoading && (
                        <Dimmer active>
                            <Loader />
                        </Dimmer>
                )}
                <Image
                    size='small'
                    loading="lazy"
                    style={{cursor: 'pointer'}}
                    onClick={this.state.isLoading ? () => {} : this.onClick.bind(this, s.id)}
                    src={this.state.isLoading ? audoryIcon : s.cover}
                    wrapped
                    ui={false} />
            </Card>
            );
        }
        return ary;
    }

    toCategory(id){
        window.scrollTo(0,0);
        this.props.history.push('/category/'+id);
      }

    onClick(id){
        /*
        window.dataLayer.push({
            event: 'onWebsiteEvent',
            eventCategory: 'audiobookSite',
            eventAction: 'playProject',
            eventLabel: 'clickPlay',
            eventValue: id
        });
        */
        window.scrollTo(0,0);
        this.props.history.push('/play/'+id);
    }

    handleGoToUser(id){
        window.scrollTo(0,0);
        this.props.history.push('/user/'+id);
    }

    renderStructure(structure){
        let ary = [];
        for(let i=0; i < structure.length; i++){
            if(structure[i].type === "single"){
                ary.push(
                    <div key={"structure_" + i} style={{marginTop: "2em", marginBottom: "2em"}}>
                        <Header as='h2'>{structure[i].title}</Header>
                        <Container text>
                            <Segment style={{cursor: 'pointer'}} onClick={() => this.onClick(structure[i].payload.id)}>
                            <Item.Group>
                                <Item>
                                    <Item.Image size='medium' src={this.state.covers[structure[i].payload.id]} />

                                    <Item.Content>
                                        <Item.Header as='a'>{structure[i].payload.title}</Item.Header>
                                        <Item.Meta>{structure[i].payload.description}</Item.Meta>
                                    </Item.Content>
                                </Item>
                            </Item.Group>
                            </Segment>
                            
                        </Container>
                        
                    </div>
                );
            } else if(structure[i].type === "list") {
                let stories = structure[i].payload;
                let carouselAry = [];
                for(let j=0; j<stories.length; j++){
                    carouselAry.push(
                        <Card key={"structure_" + i + "_card_" + j} style={{margin: 10, marginLeft: "auto", marginRight: "auto", cursor: 'pointer'}} onClick={() => this.onClick(stories[j].id)}>
                            <Image src={this.state.covers[stories[j].id]} wrapped ui={false} />
                            <Card.Content>
                                <Card.Header>{stories[j].title}</Card.Header>
                            </Card.Content>
                        </Card>
                    );
                }
                ary.push(
                    <div key={"structure_" + i} style={{marginTop: "2em", marginBottom: "2em"}}>
                        <Header as='h2'>{structure[i].title}</Header>
                        <Carousel responsive={responsive} infinite={true}>
                            {carouselAry}                            
                        </Carousel>
                    </div>
                );
            }
        }
        return ary;
    }

    render(){
        /*
        const firstStory = this.state.storys ? this.state.storys[0] : null;
        
        let authorRender = null;
        let speakerRender = null;
        if(firstStory){

            if(typeof(firstStory.authorId) !== 'string'){
                let authors = [];
                for(let k=0; k < firstStory.authorName.length; k++){
                    authors.push(
                        <b key={k} style={{cursor: "pointer"}} onClick={this.handleGoToUser.bind(this, firstStory.authorId[k])}>{`${firstStory.authorName[k].firstName} ${firstStory.authorName[k].lastName}`}</b>
                    );
                    if(k + 1 < firstStory.authorName.length) authors.push(
                       <span key={k.toString() + "-&"}>&</span>
                    );
                }
                authorRender = (
                    <p>
                        von {authors}
                    </p>
                );
            } else {
                authorRender = (
                    <p>
                        von <b style={{cursor: "pointer"}} onClick={this.handleGoToUser.bind(this, firstStory.authorId)}>{`${firstStory.authorName.firstName} ${firstStory.authorName.lastName}`}</b>
                    </p>
                );
            }
    
            
            if(typeof(firstStory.speakerId) !== 'string'){
                let speakers = [];
                for(let k=0; k < firstStory.speakerName.length; k++){
                    speakers.push(
                        <b key={k} style={{cursor: "pointer"}} onClick={this.handleGoToUser.bind(this, firstStory.speakerId[k])}>{`${firstStory.speakerName[k].firstName} ${firstStory.speakerName[k].lastName}`}</b>
                    );
                    if(k + 1 < firstStory.speakerName.length) speakers.push(
                       <span key={k.toString() + "-&"}>&</span>
                    );
                }
                speakerRender = (
                    <p>
                        gesprochen von {speakers}
                    </p>
                );
            } else {
                speakerRender = (
                    <p>
                        gesprochen von <b style={{cursor: "pointer"}} onClick={this.handleGoToUser.bind(this, firstStory.speakerId)}>{`${firstStory.speakerName.firstName} ${firstStory.speakerName.lastName}`}</b>
                    </p>
                );
            }

        }
        */
        
        return (
            <DivWrapper>
                <PageHeader />

                <Segment style={{border: 'none', minHeight: '60vh', marginTop: '2px', borderRadius: 0}}>
                        { (!this.state.isLoading) ? (
                            <Segment style={{ padding: '0em' }} vertical>
                                {this.renderStructure(this.state.structure)}

                                <Container textAlign='center' style={{marginTop: "4em", marginBottom: "4em"}}>
                                    <Header as='h1' icon>
                                        <Icon name='search' />
                                            <FormattedMessage id="audory.apppage.body.cta"/>
                                        <Header.Subheader>
                                            <FormattedMessage id="audory.apppage.body.cta.body"/>
                                        </Header.Subheader>
                                    </Header>
                                    <Segment basic>
                                        <Grid columns={2} centered>
                                            <Grid.Column style={{textAlign: 'center'}}>
                                                <Image as='a' href='https://apps.apple.com/app/id1538122365' src={applePic} style={{width: '15em'}} />
                                            </Grid.Column>
                                            <Grid.Column style={{textAlign: 'center'}}>
                                                <Image as='a' href='https://play.google.com/store/apps/details?id=com.audoryapp' src={googlePlayPic} style={{ width: '15em'}} />
                                            </Grid.Column>
                                        </Grid>
                                    </Segment>
                                </Container>
                                
                            </Segment>
                            ) : (
                                <Dimmer active>
                                    <Loader><FormattedMessage id="audory.apppage.body.loading"/></Loader>
                                </Dimmer>
                            )
                        }
                </Segment>
            
            </DivWrapper>
        );
    }
} 

/*
<Divider horizontal style={{marginBottom: '2em'}}>
                          <Header as='h1'>
                            Neuste Geschichte
                          </Header>
                        </Divider>
                        <Item.Group>
                            <Item>
                                <Item.Image size='large' style={{cursor: 'pointer'}} onClick={this.onClick.bind(this, firstStory.id)} src={firstStory.cover} />
                                <Item.Content>
                                <Item.Header as='a' onClick={this.onClick.bind(this, firstStory.id)}>{firstStory.title}</Item.Header>
                                <Item.Meta>
                                    <p>Veröffentlicht am {moment(firstStory.date_published).format("DD. MMMM YYYY")}</p>
                                    {authorRender}
                                    {speakerRender}
                                    <Label style={{cursor: 'pointer'}} onClick={this.toCategory.bind(this, firstStory.category.id)}>{firstStory.category.name}</Label>
                                    <AgeRestriction age={firstStory.ageRestriction} />
                                </Item.Meta>
                                <Item.Description>
                                    <p style={{textAlign: 'justify'}}>{firstStory.description}</p>
                                </Item.Description>
                                <Item.Extra>
                                    <Button
                                    icon
                                    color='green'
                                    labelPosition='right'
                                    floated='right'
                                    onClick={this.onClick.bind(this, firstStory.id)}
                                    >
                                    Hören
                                    <Icon name='play' />
                                    </Button>
                                </Item.Extra>
                                </Item.Content>
                            </Item>
                        </Item.Group>
                */

/*

<Segment style={{border: 'none', minHeight: '60vh', marginTop: '2px', borderRadius: 0}}>
                    { (this.state.storys && this.state.storyOriginals && this.state.storyExclusive) ? (
                        <Segment style={{ padding: '0em' }} vertical>
                        {
                            this.state.storyOriginals.length > 0 && (
                                <div>
                                    <Divider horizontal style={{marginBottom: '2em'}}>
                                    <Header as='h2'>
                                        audory Originals
                                    </Header>
                                    </Divider>
                                    <Container>
                                        <Grid>
                                            <Grid.Row only='mobile tablet'>
                                                <Card.Group itemsPerRow={2}>
                                                    {this.renderStorys(this.state.storyOriginals)}
                                                </Card.Group>
                                            </Grid.Row>
                                            <Grid.Row only='computer'>
                                                <Card.Group itemsPerRow={4}>
                                                    {this.renderStorys(this.state.storyOriginals)}
                                                </Card.Group>
                                            </Grid.Row>
                                        </Grid>
                                    </Container>
                                </div>
                            )
                        }

                        {
                            this.state.storyExclusive.length > 0 && (
                                <div>
                                    <Divider horizontal style={{marginBottom: '2em'}}>
                                    <Header as='h2'>
                                        Nur bei audory
                                    </Header>
                                    </Divider>
                                    <Container>
                                        <Grid>
                                            <Grid.Row only='mobile tablet'>
                                                <Card.Group itemsPerRow={2}>
                                                    {this.renderStorys(this.state.storyExclusive)}
                                                </Card.Group>
                                            </Grid.Row>
                                            <Grid.Row only='computer'>
                                                <Card.Group itemsPerRow={4}>
                                                    {this.renderStorys(this.state.storyExclusive)}
                                                </Card.Group>
                                            </Grid.Row>
                                        </Grid>
                                    </Container>
                                </div>
                            )
                        }
                        
                        {
                            this.state.storys.length > 0 && (
                                <div>
                                    <Divider horizontal style={{marginBottom: '2em'}}>
                                    <Header as='h2'>
                                        Weitere Geschichten
                                    </Header>
                                    </Divider>
                                    <Container>
                                        <Grid>
                                            <Grid.Row only='mobile tablet'>
                                                <Card.Group itemsPerRow={2}>
                                                    {this.renderStorys(this.state.storys)}
                                                </Card.Group>
                                            </Grid.Row>
                                            <Grid.Row only='computer'>
                                                <Card.Group itemsPerRow={4}>
                                                    {this.renderStorys(this.state.storys)}
                                                </Card.Group>
                                            </Grid.Row>
                                        </Grid>
                                    </Container>
                                </div>
                            )
                        }
                </Segment>
                    ) : (
                        <Dimmer active>
                            <Loader>Hörbücher werden geladen...</Loader>
                        </Dimmer>
                    )
                    }
            </Segment>

*/

/*(
                        
                        <Segment style={{ padding: '0em' }} vertical>
                                <Divider horizontal style={{marginBottom: '2em'}}>
                                  <Header as='h1'>
                                    Neuste Geschichte
                                  </Header>
                                </Divider>
                                <Item.Group>
                                    <Item>
                                        <Item.Image size='large' style={{cursor: 'pointer'}} onClick={this.onClick.bind(this, firstStory.id)} src={firstStory.cover} />
                                        <Item.Content>
                                        <Item.Header as='a' onClick={this.onClick.bind(this, firstStory.id)}>{firstStory.title}</Item.Header>
                                        <Item.Meta>
                                            <p>Veröffentlicht am {moment(firstStory.date_published).format("DD. MMMM YYYY")}</p>
                                            {authorRender}
                                            {speakerRender}
                                            <Label style={{cursor: 'pointer'}} onClick={this.toCategory.bind(this, firstStory.category.id)}>{firstStory.category.name}</Label>
                                            <AgeRestriction age={firstStory.ageRestriction} />
                                        </Item.Meta>
                                        <Item.Description>
                                            <p style={{textAlign: 'justify'}}>{firstStory.description}</p>
                                        </Item.Description>
                                        <Item.Extra>
                                            <Button
                                            icon
                                            color='green'
                                            labelPosition='right'
                                            floated='right'
                                            onClick={this.onClick.bind(this, firstStory.id)}
                                            >
                                            Hören
                                            <Icon name='play' />
                                            </Button>
                                        </Item.Extra>
                                        </Item.Content>
                                    </Item>
                                </Item.Group>

                                <Divider horizontal style={{marginBottom: '2em'}}>
                                  <Header as='h2'>
                                    Weitere Geschichten
                                  </Header>
                                </Divider>
                                <Container>
                                <Item.Group>
                                    {this.renderStorys(this.state.storys.slice(1,this.state.storys.length))}
                                </Item.Group>
                                </Container>
                        </Segment>
                            
                    )*/


export default AudiobooksPage;


// WEBPACK FOOTER //
// ./src/components/AudiobooksPage.js